import { cn } from '@/shared/components/shadcn/lib/utils';
import { Card, CardContent } from 'components/shadcn';
import Logo from '@/assets/logo.svg';

export const FormLayout = ({ className, children, image = null, ...props }) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-6 w-full max-w-sm md:max-w-[730px]',
        className,
      )}
      {...props}
    >
      <Card className="overflow-hidden p-0">
        <CardContent className="flex flex-col md:flex-row p-0">
          <div className="bg-muted relative hidden md:flex items-center justify-center md:w-1/2">
            <img
              src={image ?? Logo}
              alt="Logo"
              className="h-auto w-3/4 object-contain dark:brightness-[0.2] dark:grayscale"
            />
          </div>
          <div className="md:w-1/2">{children}</div>
        </CardContent>
      </Card>
    </div>
  );
};
